import { __assign } from "tslib";
import { UTM_CAMPAIGN, UTM_CONTENT, UTM_MEDIUM, UTM_SOURCE, UTM_TERM, UTMZ_SOURCE, UTMZ_MEDIUM, UTMZ_CAMPAIGN, UTMZ_TERM, UTMZ_CONTENT, GCLID, FBCLID, } from './constants';
import { UTMCookie } from './storage/utm-cookie';
import { getQueryParams } from './utils/query-params';
export var getAttributions = function (config) {
    var attributions = __assign(__assign(__assign(__assign({}, (config.includeUtm && getUtmParam())), (config.includeReferrer && getReferrer())), (config.includeGclid && getGclid())), (config.includeFbclid && getFbclid()));
    return attributions;
};
export var getUtmParam = function () {
    var params = getQueryParams();
    var utmStorage = new UTMCookie();
    var cookies = (utmStorage.isEnabled() && utmStorage.get('__utmz')) || {};
    var utmSource = params[UTM_SOURCE] || cookies[UTMZ_SOURCE];
    var utmMedium = params[UTM_MEDIUM] || cookies[UTMZ_MEDIUM];
    var utmCampaign = params[UTM_CAMPAIGN] || cookies[UTMZ_CAMPAIGN];
    var utmTerm = params[UTM_TERM] || cookies[UTMZ_TERM];
    var utmContent = params[UTM_CONTENT] || cookies[UTMZ_CONTENT];
    var data = {};
    if (utmSource)
        data.utm_source = utmSource;
    if (utmMedium)
        data.utm_medium = utmMedium;
    if (utmCampaign)
        data.utm_campaign = utmCampaign;
    if (utmTerm)
        data.utm_term = utmTerm;
    if (utmContent)
        data.utm_content = utmContent;
    return data;
};
export var getReferrer = function () {
    var _a;
    var data = {};
    try {
        var referrer = document.referrer || undefined;
        var referringDomain = (_a = referrer === null || referrer === void 0 ? void 0 : referrer.split('/')[2]) !== null && _a !== void 0 ? _a : undefined;
        if (referrer !== undefined)
            data.referrer = referrer;
        if (referringDomain !== undefined)
            data.referring_domain = referringDomain;
    }
    catch (_b) {
        //
    }
    return data;
};
export var getGclid = function () {
    var _a;
    var params = getQueryParams();
    return __assign({}, (params[GCLID] && (_a = {}, _a[GCLID] = params[GCLID], _a)));
};
export var getFbclid = function () {
    var _a;
    var params = getQueryParams();
    return __assign({}, (params[FBCLID] && (_a = {}, _a[FBCLID] = params[FBCLID], _a)));
};
//# sourceMappingURL=attribution.js.map